module.exports = __webpack_public_path__ + "static/new-gsc-logo-en-62e4b1f8fc00013109336eddcf9d8e86.png";